import { studentsConstants } from './constants';

const INITIAL_STATE = { 
    isFetching: false,
    student: {},
    myEvaluations: [],
    courseEvaluations: [],
    studentAttendance: []
 };


export function students(state = INITIAL_STATE, action) {
   switch (action.type) {

    case studentsConstants.SHOW_STUDENT:
      return {
          ...state,
          student: action.student
         };  

    case studentsConstants.UPDATE_IMAGE_PROFILE:
      return {
          ...state,
          student: {...state.student, 
                          persona: {...state.student.persona, 
                            images: action.images
                          }
                  } 
              } ;  
    
    case studentsConstants.UPDATE_STUDENT:
      return {
          ...state,
          student: {...state.student, persona: {...state.student.persona, ...action.studentUpdate}}
          };  

          
    case studentsConstants.STUDENT_ATTENDANCE:
      return {
          ...state,
          studentAttendance: action.studentAttendance
          };           

    case studentsConstants.SHOW_RELATIVES:
      return {
          ...state,
          userRelatives: action.relatives
          };  
//
          // case courseConstants.TUTOR_ENROLED:
          //   let tutorsCopy = [...state.course.tutors] ;
          //   tutorsCopy.push(action.newTutor) ;
    
          //   return {
          //       ...state,
          //       course: {...state.course, tutors: tutorsCopy}
          //   };  

//
    case studentsConstants.STUDENT_ADD_RELATED:

      let relativesCopy = [...state.student.relatives] ;
      // let rel = {...action.related, relation_type: action.relationType } ;
      // alert(rel.relation_type)
      relativesCopy.push({...action.related })

      return {
          ...state,
          student: {...state.student,  relatives: relativesCopy } 
          }; 
          
    case studentsConstants.STUDENT_REMOVE_RELATED:

      return {
          ...state,
          student: {...state.student,  relatives: state.student.relatives.filter( (rel) => rel.persona_id !== action.related_id ) }
          };

    case studentsConstants.COURSE_EVALUATIONS:
      return {
          ...state,
          courseEvaluations: action.courseEvaluations
          };  
      

    case studentsConstants.MY_EVALUATIONS:
      return {
          ...state,
          myEvaluations: action.myEvaluations
          };  
          

    case studentsConstants.UPDATE_RELATIVE:
      let relatives = [] ;

      state.student.relatives.map( orig => {
        if (orig.persona_id === action.relativeID)  relatives.push({...orig, ...action.relative})
          else relatives.push(orig) ;
        return null;
      })

      return {
          ...state,
          student: {...state.student, relatives: relatives}
          };  
     
        default:
      return state
  }
}

